var _rect, _path, _path2, _mask, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F5F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.792 37.458a2.417 2.417 0 00-2.417-2.416H37.502c.049 0 .033-.02-.073-.149a14.387 14.387 0 01-.327-.413 36.225 36.225 0 00-.147-.189c-.865-1.091-1.727-1.666-3.08-1.666h-7.25a2.417 2.417 0 00-2.416 2.417v16.916a2.417 2.417 0 002.416 2.417h21.75a2.417 2.417 0 002.417-2.417v-14.5zm-2.416 0v14.5h-21.75V35.042h7.25c.464 0 .733.18 1.186.75l.105.136c.097.125.231.298.286.366.608.753 1.173 1.16 2.041 1.164h10.882z",
    fill: "#9BAEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.916 44.708a3.625 3.625 0 11-7.25 0 3.625 3.625 0 017.25 0zm-9.666 0a6.042 6.042 0 1012.083 0 6.042 6.042 0 00-12.083 0zm13.291-4.833a1.208 1.208 0 102.417 0 1.208 1.208 0 00-2.417 0z",
    fill: "#9BAEF1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Feature-1_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 15,
    width: 24,
    height: 28,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 15h24v28H24z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 39l.658-.54C42.188 33.917 45 29.95 45 26.465 45 21.528 40.903 18 36 18s-9 3.528-9 8.465c0 3.486 2.811 7.452 8.342 11.995L36 39zm0-2.506c-4.693-3.978-7-7.35-7-10.03 0-3.858 3.164-6.583 7-6.583s7 2.724 7 6.584c0 2.68-2.307 6.05-7 10.03z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 39l.658-.54C42.188 33.917 45 29.95 45 26.465 45 21.528 40.903 18 36 18s-9 3.528-9 8.465c0 3.486 2.811 7.452 8.342 11.995L36 39zm0-2.506c-4.693-3.978-7-7.35-7-10.03 0-3.858 3.164-6.583 7-6.583s7 2.724 7 6.584c0 2.68-2.307 6.05-7 10.03z",
    fill: "#506BCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.658 38.46l1.904 2.318-1.904-2.318zM36 39l-1.904 2.318L36 42.882l1.904-1.564L36 39zm-.658-.54l-1.904 2.318 1.904-2.318zM36 36.494l-1.94 2.289L36 40.427l1.94-1.644L36 36.494zm-1.246-.352l-.658.54 3.808 4.636.658-.54-3.808-4.636zM42 26.465c0 .922-.374 2.19-1.556 3.883-1.18 1.689-3.042 3.618-5.69 5.794l3.808 4.636c2.882-2.367 5.192-4.692 6.8-6.993C46.968 31.487 48 29.029 48 26.465h-6zM36 21c3.5 0 6 2.428 6 5.465h6C48 19.628 42.306 15 36 15v6zm-6 5.465C30 23.428 32.5 21 36 21v-6c-6.305 0-12 4.628-12 11.465h6zm7.246 9.677c-2.648-2.176-4.51-4.105-5.69-5.794C30.374 28.656 30 27.387 30 26.465h-6c0 2.564 1.032 5.022 2.638 7.32 1.608 2.301 3.918 4.626 6.8 6.993l3.808-4.636zm.658.54l-.658-.54-3.808 4.636.658.54 3.808-4.636zM26 26.465c0 2.188.928 4.299 2.276 6.239 1.364 1.965 3.323 3.993 5.784 6.079l3.88-4.577c-2.232-1.893-3.774-3.54-4.736-4.925-.98-1.41-1.204-2.324-1.204-2.816h-6zm10-9.584c-5.239 0-10 3.825-10 9.584h6c0-1.96 1.567-3.584 4-3.584v-6zm10 9.584c0-5.76-4.761-9.584-10-9.584v6c2.433 0 4 1.624 4 3.584h6zm-8.06 12.318c2.46-2.086 4.42-4.114 5.784-6.08 1.348-1.94 2.276-4.05 2.276-6.238h-6c0 .492-.225 1.406-1.204 2.816-.962 1.386-2.504 3.032-4.736 4.925l3.88 4.577z",
    fill: "#F5F5F8",
    mask: "url(#Feature-1_svg__a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 27.375v-1.75h7v1.75h-7z",
    fill: "#506BCA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.125 23h1.75v7h-1.75v-7z",
    fill: "#506BCA"
  })));
}
export default __webpack_public_path__ + "media/contract/Feature-1-53fa9faf.svg";
export { SvgFeature1 as ReactComponent };